import { COLORS, IconSelector, styled, Typography } from '@msdk/ui'
import React from 'react'

const IntialsContainer = styled('div')`
  width: 64px;
  height: 64px;
  border-radius: 8px;
  background-color: ${COLORS.blue100};
  display: flex;
`

const Initials = styled(Typography)`
  margin: auto;
  text-transform: uppercase;
`

const IconContainer = styled('div')`
  width: 64px;
  height: 64px;
  border-radius: 8px;
  background-color: ${COLORS.action.selected};
  display: flex;
`

const IconWrapper = styled('div')`
  margin: auto;
`

interface Props {
  icon?: string
  intials?: string[]
}

export function HeaderIcon(props: Props) {
  return (
    <>
      {props.icon && (
        <IconContainer>
          <IconWrapper>
            <IconSelector iconName={props.icon} />
          </IconWrapper>
        </IconContainer>
      )}
      {!props.icon && (
        <IntialsContainer>
          <Initials variant="h5">{props.intials}</Initials>
        </IntialsContainer>
      )}
    </>
  )
}
